import React, { useState, useEffect, useContext } from 'react';
import { Form } from 'antd';
import Axios from 'axios';
import Moment from 'moment';

import * as COM from '.';
import * as Antd from 'antd';
import { AuthContext } from '../../containers/App';

export const DatasetFiltersTags = (props) => {
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [_, setDatasetFilters] = useState([]);
  let auth = useContext(AuthContext);

  const fetchDatasetFilters = async () => {
    try {
      let response = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/datasets`, {
        params: {
          filter: {
            where: {
              code: props.dataset
            }
          }
        }
      });
      setDatasetFilters(response.data[0].filters);
      return response.data[0].filters;
    } catch (err) {
      console.log(err);
    }
  };

  const prepareTags = async (datasetFilters) => {
    let tags = [];
    for (let datasetFilter of datasetFilters) {
      for (let aFilterIdx in props.filters) {
        if (datasetFilter.fieldName === aFilterIdx
          || datasetFilter.fieldName === aFilterIdx + ".data") {
          let title = datasetFilter.title;
          let values = null;
          let titledValues = null;
          if (datasetFilter.fieldName === aFilterIdx + ".data") {
            values = props.filters[aFilterIdx].data;
          } else {
            values = props.filters[aFilterIdx];
          }
          if (datasetFilter.type === 'input') {
            titledValues = `${values}`;
          } else if (datasetFilter.type === 'select') {
            let filterOptionTitles = [];
            for (let filterOption of datasetFilter.options) {
              if (Array.isArray(values)) {
                for (let value of values) {
                  if (filterOption.value === value) {
                    filterOptionTitles.push(`${filterOption.title}`)
                  }
                }
              } else {
                if (filterOption.value === values) {
                  filterOptionTitles.push(`${filterOption.title}`)
                }
              }
            }
            titledValues = `${filterOptionTitles.join(', ')}`;
          } else if (datasetFilter.type === 'datasetSelect' || datasetFilter.type === 'datasetTreeSelect') {
            let data = await COM.fetchData({
              connector: datasetFilter.connector,
              dataset: datasetFilter.dataset,
              filters: Object.assign(
                {},
                JSON.parse(datasetFilter.filters),
                {
                  id: { $in: Array.isArray(values) ? values : [values] }
                }
              ),
            }, auth);
            titledValues = `${data.map((c) => c.title).join(', ')}`;
          } else if (datasetFilter.type === 'dateRange') {
            titledValues = `${Moment(values[0]).format('L')} - ${Moment(values[1]).format('L')}`
          }

          tags.push(
            <Antd.Tag
              color="green"
              style={{
                padding: '4px 7px',
                marginBottom: 5
              }}
            >
              <Antd.Typography.Text strong>{title}</Antd.Typography.Text> {titledValues}
            </Antd.Tag>
          );
        }
      }
    }
    setTags(tags);
  }

  const fetchAll = async () => {
    setLoading(true);
    let datasetFilters = await fetchDatasetFilters();
    await prepareTags(datasetFilters);
    setLoading(false);
  }

  useEffect(() => {
    fetchAll();
  }, [props.filters]);

  if (loading) {
    return null;
  } else {
    return (
      <Antd.Row
        size="small"
      >
        {tags}
      </Antd.Row>
    );
  }
};
